export const VOTE_VALUES = {
  FEASIBLE: "FEASIBLE",
  PREFERRED: "PREFERRED",
};

export function normalizeVoteValue(value) {
  if (!value) return null;
  if (typeof value === "string") return value.toUpperCase();
  if (value === true) return VOTE_VALUES.FEASIBLE;
  if (typeof value === "object") {
    if (value.preferred) return VOTE_VALUES.PREFERRED;
    if (value.feasible) return VOTE_VALUES.FEASIBLE;
  }
  return null;
}

export function isAttendingVote(value) {
  const normalized = normalizeVoteValue(value);
  return normalized === VOTE_VALUES.FEASIBLE || normalized === VOTE_VALUES.PREFERRED;
}

export function hasSubmittedSchedulerVote(voteDoc) {
  if (!voteDoc || typeof voteDoc !== "object") return false;
  if (voteDoc.noTimesWork === true) return true;
  if (!voteDoc.votes || typeof voteDoc.votes !== "object") return false;
  return Object.values(voteDoc.votes).some((value) => isAttendingVote(value));
}

// Mirrors the RSVP enum in lib/rsvp-utils.js. Kept local (not imported) on
// purpose: rsvp-utils.js already imports isAttendingVote from here, so importing
// back would create a circular dependency.
const RSVP_RESPONSE_VALUES = new Set(["GOING", "MAYBE", "CANT_GO"]);

// A vote doc carries an explicit RSVP. RSVPs only exist on FINALIZED sessions
// (materialized at finalize, or set via the RSVP panel).
export function hasExplicitRsvp(voteDoc) {
  return Boolean(voteDoc && RSVP_RESPONSE_VALUES.has(voteDoc.rsvp));
}

// Whether a participant has "responded" to a session for ATTENDANCE purposes: a
// submitted slot vote, OR — on a FINALIZED session — an explicit RSVP with no
// slot vote (e.g. they RSVP'd Going straight on the finalized poll, "0 voted").
// A participant with neither stays "unresponded" — this never fabricates a
// response for someone who never voted.
export function hasRespondedToScheduler(voteDoc, { isFinalized = false } = {}) {
  if (hasSubmittedSchedulerVote(voteDoc)) return true;
  return Boolean(isFinalized) && hasExplicitRsvp(voteDoc);
}

export function nonCreatorHasVoted(voteDocs, creatorId) {
  if (!Array.isArray(voteDocs) || creatorId == null || creatorId === "") return false;
  const creatorIdString = String(creatorId);
  return voteDocs.some(
    (voteDoc) => hasSubmittedSchedulerVote(voteDoc) && String(voteDoc?.id) !== creatorIdString
  );
}
